module.exports = __webpack_public_path__ + "img/coockies.128850ff.svg";